import { Link } from "react-router-dom";
import { Lightbulb, ArrowRight } from "lucide-react";

export const JourneyTip = ({ fr }) => (
  <Link to="/litter-journey" data-testid="profile-journey-tip"
    className="group flex items-center gap-3 rounded-2xl border border-[#F5551E]/20 bg-[#FFF4F0] px-4 py-3 mb-4 hover:border-[#F5551E]/50 transition-colors">
    <span className="shrink-0 h-9 w-9 rounded-xl bg-white text-[#F5551E] flex items-center justify-center"><Lightbulb size={18} /></span>
    <span className="text-sm text-[#12234A] flex-1">
      <strong>{fr ? "Première fois sur une liste d'attente ?" : "New to waitlists?"}</strong>{" "}
      {fr ? "Voyez ce qui se passe de l'annonce jusqu'aux photos des bébés." : "See what happens from the announcement right up to the baby photo emails."}
    </span>
    <span className="shrink-0 text-xs font-bold text-[#F5551E] inline-flex items-center gap-1 group-hover:gap-2 transition-[gap]">{fr ? "Le guide" : "Read the guide"} <ArrowRight size={14} /></span>
  </Link>
);
